import { Button, Card, Flex, Space, Tag } from 'antd'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'

import { GetTreatmentPlanRecipeResponse, QrCodeType } from 'src/api/requests'
import { CallIcon } from 'src/assets'
import { QRCode, Text } from 'src/components'
import { getRecipeStatus } from 'src/features/persons/utils'
import { dayMonthYearHourMinutesFormatSeparator } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  data?: GetTreatmentPlanRecipeResponse
}

export const RecipesHeader = ({ data }: Props) => {
  const { t } = useLocales()
  const { treatmentPlanId } = useParams()

  const { styles } = useStyles()

  return (
    <Flex gap={16}>
      <Card className={styles.headerCard}>
        <Flex vertical gap={8} className="full-width">
          <Flex justify="space-between">
            <Space>
              <Text weight={400}>{t('investigations.created_date')}</Text>
              <Text strong>
                {dayjs(data?.created).format(
                  dayMonthYearHourMinutesFormatSeparator
                )}
              </Text>
            </Space>

            <Tag color={getRecipeStatus(t, data?.status).color}>
              {getRecipeStatus(t, data?.status).text}
            </Tag>
          </Flex>

          <Space>
            <Text weight={400}>
              {t('recipes.person_who_created_the_recipe')}
            </Text>
            <Text strong>
              {data?.issuedBy?.firstName} {data?.issuedBy?.lastName} -{' '}
              {data?.legalEntity?.name}
            </Text>
            <Button
              disabled={false}
              onClick={() =>
                window.open(`tel:${data?.issuedBy?.phoneNumber}`, '_blank')
              }
            >
              <CallIcon /> {data?.issuedBy?.phoneNumber}
            </Button>
          </Space>
        </Flex>
      </Card>
      <Card
        styles={{
          body: {
            padding: 16
          }
        }}
      >
        <QRCode
          value={`${window.location.origin}/prescriptions/${treatmentPlanId}/${data?.id}`}
          type={QrCodeType.MEDICAL_RECEIPT}
          content={`${treatmentPlanId} ${data?.id}`}
        />
      </Card>
    </Flex>
  )
}
